import { Controller } from "@hotwired/stimulus"

// A single select with fewer options than this opens as a plain dropdown; longer
// ones get a search box.
const SEARCH_MIN_OPTIONS = 8

// Turns a <select> into a TomSelect: a searchable dropdown, or chips for `multiple`.
// The underlying <select> stays the source of truth, so forms post exactly what they
// posted before and `change` listeners keep working.
//
// tom-select is not in application.js: it is its own bundle (app/javascript/tom_select.js),
// imported on the first connect from the digested URL the layout publishes in
// <meta name="tom-select-src">. Most pages have no select to enhance. If the import
// fails (a page left open across a deploy), the native <select> keeps working.
export default class extends Controller {
  async connect() {
    try {
      const { default: TomSelect } = await import(document.querySelector("meta[name='tom-select-src']").content)
      if (!this.element.isConnected || this.element.tomselect) return

      this.tomSelect = new TomSelect(this.element, this.settings())
    } catch (error) {
      console.error("tom-select unavailable, keeping the native select", error)
    }
  }

  disconnect() {
    this.tomSelect?.destroy()
    this.tomSelect = null
  }

  settings() {
    if (this.element.multiple) return { plugins: ["remove_button"], closeAfterSelect: false, hidePlaceholder: true }

    const settings = { allowEmptyOption: true }
    if (this.element.options.length < SEARCH_MIN_OPTIONS) settings.controlInput = null
    return settings
  }
}
